<template>
    <v-layout row wrap class="pl-3 pr-2">
        <v-flex xs12>
            <v-divider class="my-3"></v-divider>
        </v-flex>
        <confirmation-header-text
            text="NRN visa details"
            class="ml-2"
            icon="mdi-account-outline"
        ></confirmation-header-text>

        <v-flex sm6 xs12>
            <list-item-detail
                :sub_title="application_data.full_address"
                :title="'Full address of ' + extendConvertVisaDetails.country_name"/>
        </v-flex>
        <v-flex sm6 xs12>
            <list-item-detail
                :sub_title="application_data.full_address_nepal"
                title="Full address of nepal"
            />
        </v-flex>
        <v-flex sm6 xs12>
            <list-item-detail
                :sub_title="application_data.nrn_card_expiry_date"
                title="NRN card expiry date"/>
        </v-flex>
        <v-flex sm6 xs12>
            <list-item-detail
                :sub_title="application_data.nrn_card_expiry_date"
                title="Nrn card expiry date"/>
        </v-flex>
    </v-layout>
</template>

<script>
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";
    import ListItemDetail from "../../ListItemDetail";

    export default {
        computed: {
            application_data() {
                return this.$store.state.VisaSingle.visa.extra.application_data;
            },
            extendConvertVisaDetails() {
                return this.$store.state.VisaSingle.extendConvertVisaDetail;
            }
        },
        components: {
            ListItemDetail,
            ConfirmationHeaderText
        }

    };
</script>

<style>
</style>
